import StarsIcon from '@mui/icons-material/Stars';
import { MainHeader } from './headers/main-header/MainHeader';
import { EnvironmentIndicator } from '../_global/navigation/Sidebar';
import AskMooChat from '../../components/ask-moo/components/AskMooChat';
import { useAskMooEnabled } from '../../components/ask-moo/hooks/useAskMooEnabled';
import { useEnvQuery } from '../../queries/useEnvQuery';

interface Props {
  children: any;
}

export function ConsoleLayout({ children }: Props) {
  const askMooEnabled = useAskMooEnabled();
  const { data: env, isInitialLoading } = useEnvQuery();
  const showEnvBanner = !isInitialLoading && !env?.prod;

  // Keep the banner flush against the header for EVERY persona: the fixed
  // header's height is content-sized and differs per persona (Cowbell's is not
  // the Agency one), so a hardcoded rem clearance leaves a gap. MainHeader
  // publishes its live height as --console-header-h; clear exactly that.

  return (
    <div className="main-root-wrapper">
      <MainHeader />
      <EnvironmentIndicator
        show={showEnvBanner}
        className="flex align-center"
        // The fallback is the banner's own default, for the moment before
        // MainHeader has published its height.
        style={{ marginTop: 'var(--console-header-h, calc(5.4rem + 3px))' }}
      >
        <span className="flex align-center">
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <StarsIcon color="#fff" style={{ marginRight: 8 }} />
          Not Production
        </span>
      </EnvironmentIndicator>
      {/*
        MainHeader is position:fixed (clears itself via the 5.4rem top
        padding below), so a normal-flow banner placed after it needs its
        own marginTop to clear the header (see EnvironmentIndicator's
        styles) — and main-root-container's own top padding must then drop
        to 0 here, or the header gets cleared twice (banner's marginTop +
        the container's own padding-top stacking into a double gap).
      */}
      <div
        className="main-root-container"
        style={showEnvBanner ? { paddingTop: 'var(--tile-gutter)' } : undefined}
      >
        {children}
      </div>
      {askMooEnabled && <AskMooChat />}

      {/* <Container maxWidth={false} className="main-root-container">
        {children}
      </Container> */}
    </div>
  );
}
